// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  position: relative;
}

.sub-titlebar {
  font-size: 11px;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  display: flex;
  z-index: 10000;
}
.sub-titlebar input {
  z-index: 5;
}
.sub-titlebar ::ng-deep .mat-mdc-form-field-infix {
  min-width: unset !important;
  width: auto !important;
}

.ticker {
  line-height: 1rem;
  height: 1rem;
}

.description {
  font-size: 10px;
  line-height: 10px;
  opacity: 0.6;
}

.indicator-row {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 5px;
  margin-left: 5px;
}

.button-container {
  display: flex;
  gap: 8px;
}

.network {
  position: absolute;
  top: 10px;
  right: 80px;
  color: rgba(255, 255, 255, 0.5);
  z-index: 1000;
  font-size: 12px;
}

.candleStickContainer {
  height: 100%;
}

#searchInput,
#searchInput:focus-visible {
  border: none;
  font-size: 10px;
  width: calc(100% - 20px);
  outline: none;
  padding: 5px;
}

.virtual-scroll {
  height: 20vh;
  width: 280px;
  overflow-x: hidden;
  overflow-y: scroll !important;
  scrollbar-color: black white;
  scrollbar-width: thin;
}

.item {
  box-sizing: border-box;
  height: 50px;
  width: 100%;
  display: flex;
}

::ng-deep .mat-mdc-menu-panel {
  overflow-x: hidden !important;
}

::ng-deep .mat-mdc-select,
::ng-deep .mat-mdc-option {
  font-size: unset !important;
}

.loading {
  color: rgba(255, 255, 255, 0.8);
}

app-spinner {
  z-index: 100;
  position: absolute;
  top: calc(50% - 50px);
  left: calc(50% - 50px);
  width: 100px;
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/stream-widget/stream-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,eAAA;EAEA,gBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;AAAF;AACE;EACE,UAAA;AACJ;AAEE;EACE,2BAAA;EACA,sBAAA;AAAJ;;AAIA;EACE,iBAAA;EACA,YAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,QAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,aAAA;EACA,eAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;;EAEE,YAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,4BAAA;EACA,qBAAA;AADF;;AAIA;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AADF;;AAIA;EACE,6BAAA;AADF;;AAIA;;EAEE,2BAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AADF","sourcesContent":[".content {\n  position: relative;\n}\n\n.sub-titlebar {\n  font-size: 11px;\n\n  padding: 4px 8px;\n  align-items: center;\n  gap: 4px;\n  display: flex;\n  z-index: 10000;\n  & input {\n    z-index: 5;\n  }\n\n  ::ng-deep .mat-mdc-form-field-infix {\n    min-width: unset !important;\n    width: auto !important;\n  }\n}\n\n.ticker {\n  line-height: 1rem;\n  height: 1rem;\n}\n\n.description {\n  font-size: 10px;\n  line-height: 10px;\n  opacity: 0.6;\n}\n\n.indicator-row {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px;\n  margin-left: 5px;\n}\n\n.button-container {\n  display: flex;\n  gap: 8px;\n}\n\n.network {\n  position: absolute;\n  top: 10px;\n  right: 80px;\n  color: rgba(255, 255, 255, 0.5);\n  z-index: 1000;\n  font-size: 12px;\n}\n\n.candleStickContainer {\n  height: 100%;\n}\n\n#searchInput,\n#searchInput:focus-visible {\n  border: none;\n  font-size: 10px;\n  width: calc(100% - 20px);\n  outline: none;\n  padding: 5px;\n}\n\n.virtual-scroll {\n  height: 20vh;\n  width: 280px;\n  overflow-x: hidden;\n  overflow-y: scroll !important;\n  scrollbar-color: black white;\n  scrollbar-width: thin;\n}\n\n.item {\n  box-sizing: border-box;\n  height: 50px;\n  width: 100%;\n  display: flex;\n}\n\n::ng-deep .mat-mdc-menu-panel {\n  overflow-x: hidden !important;\n}\n\n::ng-deep .mat-mdc-select,\n::ng-deep .mat-mdc-option {\n  font-size: unset !important;\n}\n\n.loading {\n  color: rgba(255, 255, 255, 0.8);\n}\n\napp-spinner {\n  z-index: 100;\n  position: absolute;\n  top: calc(50% - 50px);\n  left: calc(50% - 50px);\n  width: 100px;\n  height: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
